import React, { useContext, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Button, SpaceBetween, SideNavigation, Container } from '@amzn/awsui-components-react-v3';

import { AppContext } from '../../store/appContext';

import { ExecutionsTabbed } from '../ExecutionStatus/ExecutionsTabbed';
import { getBaseExceptionUrl } from '../Utils/Utils';

interface NotificationsProps {
  onClickExceptionLink: () => void;
}

export const Notifications = ({ onClickExceptionLink }: NotificationsProps) => {
  const [show, setShow] = useState(false);
  const { appType } = useContext(AppContext);
  const ref = useRef(null);
  const { receiveType }: any = useParams();
  const InventoryAdjustment = receiveType === 'inventory_adjustment';

  const redirectUnifiedRecieveApp = !InventoryAdjustment
    ? {
      type: 'link',
      text: 'Inventory Adjustment',
      href: '/inventory-receive/receive/inventory_adjustment',
      external: true,
    }
    : {
      type: 'link',
      text: 'Unified Receive',
      href: '/inventory-receive/receive',
      external: true,
    };

  useEffect(() => {
    const onHandleDocumentClick = (e: MouseEvent) => {
      if (!ref?.current?.contains(e.target)) {
        setShow(false);
      }
    };

    const onHandleDocumentKeyup = (e: KeyboardEvent) => {
      if (e.code === 'Escape' && show) {
        setShow(false);
      }
    };

    document.addEventListener('click', onHandleDocumentClick);
    document.addEventListener('keydown', onHandleDocumentKeyup);
    return () => {
      document.removeEventListener('click', onHandleDocumentClick);
      document.removeEventListener('keydown', onHandleDocumentKeyup);
    };
  }, [show, setShow]);

  const SIDE_NAV_LINKS = [
    {
      type: 'link',
      text: 'Switch to Other App',
      href: globalThis.location.origin,
      external: true,
    },
    { type: 'divider' },
    {
      type: 'section-group',
      title: 'Exceptions',
      items: [
        {
          type: 'link',
          text: 'Search Receive Exceptions',
          href: `${getBaseExceptionUrl(appType)}/search`,
          external: true,
        },
      ],
    },
    { type: 'divider' },
    {
      type: 'link',
      text: 'Unified Receive User Guide',
      href: 'https://amazon.awsapps.com/workdocs/index.html#/document/261f2cd7895d9f8569a4d56ecc7de514283373f2cdb367ae1594c7d8dd857081',
      external: true,
    },
    {
      type: 'link',
      text: 'Report a Bug',
      href: 'https://t.corp.amazon.com/create/templates/19c6ca30-aee7-4daa-8de9-238212f71516',
      external: true,
    },
    {
      type: 'link',
      text: 'Feature Requests',
      href: 'https://sim.amazon.com/issues/create?assignedFolder=3c560e8c-40cd-4a2b-a56a-7c50887c13ab',
      external: true,
    },
  ];

  const NAV_LINKS = [redirectUnifiedRecieveApp, ...SIDE_NAV_LINKS];

  return (
    <div className="executions-notifications" ref={ref}>
      <Button variant="icon" ariaLabel="menu-icon-navigation" iconName="menu" onClick={() => setShow(!show)} />
      {show && (
        <div className="top-nav-menu">
          <Container>
            <SpaceBetween direction="horizontal" size="s" data-nav="top-nav">
              <SideNavigation
                items={NAV_LINKS}
                onFollow={(e) => {
                  /* istanbul ignore next */
                  if (e?.detail?.href === '') {
                    e.preventDefault();
                    e.stopPropagation();
                    onClickExceptionLink && onClickExceptionLink();
                  }
                }}
              />
              <ExecutionsTabbed closeMenu={() => { }} />
            </SpaceBetween>
          </Container>
        </div>
      )}
    </div>
  );
};
